/**
- @설명 : 전자금융 정보 slice
*/
export interface elecFinanceInfo {
    // ↓ TOBE ↓

    /**
     * @dec 스마트뱅킹 신청 구분
     * @arg
     * smbkAplc : 스마트뱅킹 신청

     * smbkOtp  : 디지털 OTP 등록

     * smbkTrmt : 스마트뱅킹 해지
     * @type {string}
     */
    smbkGubun?: string

    /**
     * @dec 스마트뱅킹 해지 후 재신청여부
     * @type {string}
     */
    isReJoin?: boolean

    /**
     * @dec 상품코드
     * @type {string}
     */
    allPdcd?: string

    /**
     * @dec 한도계좌여부
     * @type {string}
     */
    lmtAcntYn?: string

    /**
     * @dec OTP 제조사명
     * @type {string}
     */
    cdNm?: string

    /** 인증서 상태값
     * @type {string}
     */
    certStatus?: string

    /** 유효기간시작
     * @type {string}
     */
    validFrom?: string

    /** 유효기간끝
     * @type {string}
     */
    validTo?: string

    /** 인증서 RID
     * @type {string}
     */
    userId?: string

    /** 인증서 시리얼
     * @type {string}
     */
    certSerial?: string

    /** 인증서 DN
     * @type {string}
     */
    userDn?: string

    /////////////////////////////// ↓ ASIS ↓ ///////////////////////////////

    /**
     * @dec E뱅킹사용자로그인ID (미사용)
     * @type {string}
     */
    ebnkUserLgnId?: string

    /** ONEID PWD (미사용)
     * @type {string}
     */
    pwd?: string

    /** 출금계좌번호
     * @type {string}
     */
    cusAcn?: string

    /** 해외IP차단여부
     * @type {string}
     * @arg
     * default value : 'N'
     */
    ovrsIpIntcYn?: string

    /** 보안매체구분코드
     * @type {string}
     * @arg
     * 1.보안카드 2.OTP 3.디지털OTP
     */
    secuMdiaDcd?: string

    /** OTP고유번호
     * @type {string}
     */
    otpUqn?: string

    /** OTP업체코드
     * @type {string}
     */
    otpCopcd?: string

    /** OTP이용범위구분코드
     * @type {string}
     * @arg
     * secuMdiaDcd  === '2' ? '1' : ""
     */
    otpUtlRngDcd?: string

    /** OTP타기관자동등록여부
     * @type {string}
     */
    otpIobDcd?: string //''//				//Y    이름변경: OTP_IOB_DCD OTP_OTIN_ATRG_YN'

    /** 인터넷뱅킹고객별총이체한도금액
     * @type {string}
     */
    itbkPcstTtalTrlmAmt?: string

    /** 고객1일이체한도금액
     * @type {string}
     */
    itbkDatfLmtAmt?: string //이름변경: ITBK_DATF_LMT_AMT CUS_DD1_TRLM_AMT

    /** 1회이체한도금액
     * @type {string}
     */
    itbkRnd1TrlmAmt?: string //이름변경: ITBK_RND1_TRLM_AMT RND1_TRLM_AMT

    /** 텔레뱅킹신청여부
     * @type {string}
     * @arg
     * default value : 'N'
     */
    tlbnAplcYn?: string

    /** 휙서비스신청여부
     * @type {string}
     */
    qcklSvcJnngYn?: string

    /** SMS수신여부
     * @type {string}
     * @arg
     * default value : 'Y'
     */
    smsRcctYn?: string

    /** 빠른조회서비스거래여부
     * @type {string}
     * @arg
     * default value : 'Y'
     */
    fsisTrnYn?: string // 'Y'

    /** 전자금융사기예방서비스신청구분코드
     * @type {string}
     * @arg
     * default value : '04'
     */
    ebkFrdPrveSrapDcd?: string

    /** OTP발급금융기관코드
     * @type {string}
     */
    otpIsncFnncIcd?: string

    /** OTP카드번호
     * @type {string}
     */
    otpCdn?: string

    /** 계좌1일이체한도금액
     * @type {string}
     */
    acntDd1TrlmAmt?: string

    /** 계좌1회이체한도금액
     * @type {string}
     */
    acntRnd1TrlmAmt?: string

    /** 출금계좌 비밀번호
     * @type {string}
     */
    acntPwd?: string // ''

    /** 관리부점코드
     * @type {string}
     */
    mngmBrcd?: string //''

    usrNo?: string //''
    rnn?: string //''
    trnHms?: string //'//거래시각'
    cpn?: string //''
    hando?: string //''
}

export const initialState: elecFinanceInfo = {
    smbkGubun: '',
    isReJoin: false,
    allPdcd: '',
    lmtAcntYn: '',
    cdNm: '',

    certStatus: '',
    validFrom: '',
    validTo: '',
    userId: '',
    certSerial: '',
    userDn: '',

    ebnkUserLgnId: '',
    pwd: '',
    cusAcn: '',
    tlbnAplcYn: '',
    ovrsIpIntcYn: '',
    qcklSvcJnngYn: '',
    smsRcctYn: '',
    fsisTrnYn: '',
    otpIobDcd: '',
    ebkFrdPrveSrapDcd: '',
    secuMdiaDcd: '',
    otpIsncFnncIcd: '',
    otpUtlRngDcd: '',
    otpUqn: '',
    otpCopcd: '',
    otpCdn: '',
    itbkPcstTtalTrlmAmt: '',
    itbkDatfLmtAmt: '',
    itbkRnd1TrlmAmt: '',
    acntDd1TrlmAmt: '',
    acntRnd1TrlmAmt: '',
    acntPwd: '',
    mngmBrcd: '',
    usrNo: '',
    rnn: '',
    trnHms: '',
    cpn: '',
    hando: '',
}
